<template>
  <div class="row">
    <div class="col-md-12">
      <select-equipe-profissional
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :callbackOnChangeProfissional="onChangeProfissional"
      >
      </select-equipe-profissional>
    </div>
    <div class="col-md-12">
      <div class="info-table" style="justify-content: flex-end">
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="busca-ativa"
          >
          </download-files>
        </div>
      </div>
      <TabelaCadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      />
    </div>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import * as Functions from './functions.js'
import SelectEquipeProfissional from '@/components/utils/SelectEquipeProfissional.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import Subtitle from './Subtitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'BuscaAtivaPorEquipeAcs',
  components: {
    SelectEquipeProfissional,
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      equipe: '',
      profissionais: [],
      profissional: '',
      cadastros: [],
      loading: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == null) {
        this.cadastros = []
        return
      }
      this.equipe = event
      try {
        this.loading = true
        let response = await this.$api.get(
          '/app/busca-ativa/equipe/' +
            this.$store.state.cod_ibge +
            '/' +
            this.equipe.nu_ine
        )
        if (response) {
          this.cadastros = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == null) {
        this.cadastros = []
        return
      }
      this.profissional = event.nu_cpf
      this.buscarDados()
    },

    // busca os dados de acordo com os valores do select
    async buscarDados() {
      try {
        this.loading = true
        let profissional = await this.$api.get(
          '/app/profissional/' +
            this.profissional +
            '/' +
            this.$store.state.cod_ibge
        )
        if (profissional) {
          let response = await this.$api.get(
            '/app/busca-ativa/acs/' +
              profissional.data.co_ibge +
              '/' +
              profissional.data.nu_cpf
          )
          if (response) {
            this.cadastros = []
            this.cadastros = response.data
            this.loading = false
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.profissional
      )
    },
  },
  created() {},
}
</script>

<style></style>
